// extracted by mini-css-extract-plugin
export default {"GoodyModal":"styles_GoodyModal__PHbmv","FoundRabbitGoodyTemplate":"styles_FoundRabbitGoodyTemplate__mvTDH"};